import { Icon, IconProps } from '@shopify/polaris';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import Dropdown from '../dropdown';

const PickerButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DatePickerContainer = styled.div`
  margin-right: 16px;
  align-items: center;
  flex: 1;
  cursor: pointer;
  .Polaris-Button {
    padding: 16px;
  }

  .Polaris-Button__Text {
    width: 100%;
  }
`;

const PickerTitleIcon = styled.div`
  display: flex;
  align-items: center;
`;

const PickerIcon = styled.div`
  margin-right: 10px;
`;

const PickerButtonTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #8c9196;
  margin-right: 10px;
`;

const PickerButtonValue = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #202223;
  flex: 1;
  text-align: right;
`;

export type PickerButtonProps = {
  disabled?: boolean;
  icon: IconProps;
  title: string;
  value: React.ReactNode;
};

export const PickerButtonActivator: FunctionComponent<PickerButtonProps> = ({
  icon,
  title,
  value,
}) => (
  <PickerButtonContainer>
    <PickerTitleIcon>
      <PickerIcon>
        <Icon {...icon} />
      </PickerIcon>
      <PickerButtonTitle>{title}</PickerButtonTitle>
    </PickerTitleIcon>
    <PickerButtonValue>{value}</PickerButtonValue>
  </PickerButtonContainer>
);

const PickerButton: FunctionComponent<PickerButtonProps> = ({
  children,
  disabled,
  icon,
  title,
  value,
}) => {
  return (
    <DatePickerContainer>
      <Dropdown
        disabled={disabled}
        activator={
          <PickerButtonActivator icon={icon} title={title} value={value} />
        }
        disclosure={false}
        fullWidth
      >
        {children}
      </Dropdown>
    </DatePickerContainer>
  );
};
export default PickerButton;
